import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { colors } from '@styles/colors';

/**
 * Botón circular rojo para eliminar en tablas (mismo tamaño que BotonIconoTabla).
 * @param {string} [tooltipText='Eliminar'] - title y aria-label
 * @param {function} onClick
 * @param {boolean} [disabled=false]
 */
function BotonIconoTablaDelete({ tooltipText = 'Eliminar', onClick, disabled = false }) {
  return (
    <button
      type="button"
      title={tooltipText}
      aria-label={tooltipText}
      onClick={onClick}
      disabled={disabled}
      style={{
        width: '4.2vh',
        height: '4.2vh',
        borderRadius: '50%',
        border: 'none',
        backgroundColor: disabled ? colors.gray400 : colors.delete,
        color: colors.white,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: 0,
      }}
    >
      <DeleteIcon style={{ fontSize: '2.4vh' }} />
    </button>
  );
}

export default BotonIconoTablaDelete;
